<template>

  <div class="padded">
    <div class="dash-heading"><i class="fa fa-globe" />&nbsp;Property Summary</div><br />
    <br />

    <el-row :gutter="12" type="flex">
      <el-col v-if="stats.landlords" align="center">
        <dash-text caption="Active Landlord" icon="fa fa-home" :value="stats.landlords" url="/property/landlords" />
      </el-col>
      <el-col v-if="stats.averageRental" align="center">
        <dash-text caption="Avg Rental" icon="fa fa-money-bill-wave" color="seagreen" currency :value="stats.averageRental" url="/property/rentals" />
      </el-col>
      <el-col v-if="stats.expiryTenancy" align="center">
        <dash-text caption="Expiring Tenancies" icon="fa fa-calendar-day" color="indianred" no-plural :value="stats.expiryTenancy" url="/property/expiry" />
      </el-col>
    </el-row>

    <hr v-if="stats.landlords || stats.averageRental || stats.expiryTenancy" />
    <h3>Expiring Tenancies Calendar</h3>
    <p />
    <events-calendar category="tenancy" />

    <hr />

    <property-charts :show-details="true" />

</div>
</template>

<script>

import NumberMixins from '@/mixins/NumberMixins'

import DashText from '@/components/atoms/DashText'
import PropertyCharts from '@/components/dashboard/charts/PropertyCharts'
import EventsCalendar from '@/components/atoms/EventsCalendar'

export default {
  mixins: [NumberMixins],

  components: {
    DashText,
    EventsCalendar,
    PropertyCharts
  },

  props: {
    showGraph: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      stats: this.getStats()
    }
  }
}
</script>
